import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Store from 'store/store';
import { touch } from 'redux-form';
import { Paper } from '@material-ui/core';

const { connect } = Store;

const useStyles = makeStyles({
  label: {
    fontSize: '0.8rem'
  },
  autocomplete: {
    borderRadius: '25px',
    '& .MuiAutocomplete-popupIndicator': {
      display: 'block'
    },
    '& .MuiInput-formControl': {
      '&::before': {
        borderWidth: ({ isError }: { isError: boolean }) =>
          isError ? '2px' : '1px',
        borderColor: ({ isError }: { isError: boolean }) =>
          isError ? 'red' : 'inherit'
      }
    }
  },
  icon: {
    width: '24px',
    height: '24px'
  },
  iconBox: {
    position: 'absolute',
    right: 0,
    top: '2px',
    width: '24px',
    height: '24px'
  },
  inputField: {
    position: 'relative'
  },
  warn: {
    color: 'red',
    fontWeight: 400
  },
  popUp: {
    width: 'max-content'
  }
});

interface Option {
  value: string | number;
  name: string;
}

interface SelectFieldProps {
  input: any;
  meta: { touched: boolean; error: boolean; invalid: boolean; form: string };
  options: Option[];
  label?: string;
  name: string;
  shrink?: boolean;
  fullWidth?: boolean;
  placeholder?: string;
  className?: string;
  touchField: (form: string, fields: string) => void;
}

const SelectSearch = ({
  options,
  placeholder,
  label,
  input,
  shrink = false,
  meta,
  touchField
}: SelectFieldProps) => {
  const { onChange, value } = input;

  const isValueProvided = !!value;
  const isError = meta.touched && meta.invalid;

  const emptyState = {
    value: null,
    name: ''
  };
  const selected = value
    ? options.find(option => Number(value) === Number(option.value))
    : emptyState;
  const classes = useStyles({ isError });

  return (
    <div className={classes.inputField}>
      <Autocomplete
        className={classes.autocomplete}
        id="provider"
        forcePopupIcon
        value={selected}
        options={[...options]}
        onChange={(_ev, option) => {
          onChange(option.value);
        }}
        onBlur={() => touchField(meta.form, input.name)}
        disableClearable
        autoHighlight
        getOptionLabel={option => {
          return option.name;
        }}
        popupIcon={<ExpandMoreIcon />}
        renderOption={({ name }) => {
          return <span className={classes.label}>{name}</span>;
        }}
        PaperComponent={({ children }) => (
          <Paper className={classes.popUp}>{children}</Paper>
        )}
        renderInput={params => {
          return (
            <TextField
              {...params}
              label={label}
              InputLabelProps={{
                shrink: shrink || isValueProvided,
                className: isError ? classes.warn : undefined
              }}
              inputProps={{
                ...params.inputProps,
                placeholder: placeholder,
                autoComplete: 'off' // disable autocomplete and autofill,
              }}
            />
          );
        }}
      />
      <div className={classes.iconBox}>
        {isError && (
          <Tooltip title={meta.error} arrow>
            <ErrorOutlineIcon
              className={classes.icon}
              style={{ color: 'red' }}
            />
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default connect(null, {
  touchField: touch
})(SelectSearch);
